export default {"src":"/_next/static/media/close-mobile.cc3d0b40.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};